import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { InsertPasswordModule } from '../shared/insert-password/insert-password.module';
import { RecoveryCodesModule } from '../shared/recovery-codes/recovery-codes.module';
import { ReadRecoveryCodesComponent } from './read-recovery-codes.component';
import { GenerateStepComponent } from './steps/generate-step/generate-step.component';

@NgModule({
  entryComponents: [
    ReadRecoveryCodesComponent
  ],
  declarations: [
    ReadRecoveryCodesComponent,
    GenerateStepComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    TranslateModule,

    InsertPasswordModule,
    RecoveryCodesModule,

    MatIconModule,
    MatButtonModule
  ],
  exports: [
    ReadRecoveryCodesComponent
  ],
  providers: [
    RecoveryCodesModule
  ]
})
export class ReadRecoveryCodesModule { }
